// import Client from "./Client";
import { /* InteractionType,*/ ClientEventScreen } from "../dtos/KioskDtos.dtos";

const moment = require('moment');

class TimerManager {
    private inactivityDelay: number = 35;

    private sessionTimer: any;
    private lastActiveTime: Date;
    private activityInterval: any;

    // private currentScreen: ClientEventScreen;

    private moveFunction: () => void;
    private showInactivityPopup: () => void;

    public setCurrentScreen(value: ClientEventScreen) {
        // this.currentScreen = value;
    }

    public setupMoveFunction(moveFunction: () => void, showInactivityPopup: () => void) {
        this.moveFunction = moveFunction;
        this.showInactivityPopup = showInactivityPopup;
    }

    public startTimer(sessionTimeSpan: number) {
        this.stopTimer();
        const totalNumberOfMilliseconds = 1000 * 60 * 60 * sessionTimeSpan;
        this.sessionTimer = setTimeout(() => { location.reload(); this.stopTimer(); }, totalNumberOfMilliseconds);
    }

    public stopTimer() {
        clearTimeout(this.sessionTimer);
        clearInterval(this.activityInterval);
    }

    public clearEventListeners() {
        document.removeEventListener('click', this.updateLastActiveTime, false);
        document.removeEventListener("mousemove", this.updateLastActiveTime, false);
        document.removeEventListener("touchmove", this.updateLastActiveTime, false);
        document.removeEventListener("click", this.updateLastActiveTime, false);
        document.removeEventListener("scroll", this.updateLastActiveTime, false);
        document.removeEventListener("keypress", this.updateLastActiveTime, false);
        clearInterval(this.activityInterval);
    }

    public setUpInactivityTimer(move: () => void, showInactivityPopup: () => void, inactivityDelay: number) {
        this.moveFunction = move;
        this.showInactivityPopup = showInactivityPopup;
        this.inactivityDelay = inactivityDelay;
        this.clearEventListeners();
        document.addEventListener("mousemove", this.updateLastActiveTime);
        document.addEventListener("touchmove", this.updateLastActiveTime);
        document.addEventListener("click", this.updateLastActiveTime);
        document.addEventListener("scroll", this.updateLastActiveTime);
        document.addEventListener("keypress", this.updateLastActiveTime);
        this.updateLastActiveTime();
    }

    public stopInactivityListener() {
        clearInterval(this.activityInterval);
    }
    public resetInactivityListener() {
        this.stopInactivityListener();
        this.updateLastActiveTime();
        this.activityInterval = setInterval(this.checkForInactivity, 5000, true);
    }

    private checkForInactivity = () => {
        const now = moment();
        const difference = Math.floor((now.diff(moment(this.lastActiveTime)) / 1000));
        if (difference >= this.inactivityDelay) {
            this.moveFunction();
            // Client.logInteractionEvent(InteractionType.InactivityDisplayedAndTriggered, this.currentScreen);
        }
        if (difference >= (this.inactivityDelay - 12) && difference <= (this.inactivityDelay - 8)) {
            this.showInactivityPopup();
        }
    }

    private updateLastActiveTime = () => {
        this.lastActiveTime = new Date();
    }
}
export default new TimerManager();


// WEBPACK FOOTER //
// ./src/services/TimerManager.ts